import { gql } from 'graphql-tag'
import {
  CreateTaskTemplateMutation,
  CreateTaskTemplateMutationVariables,
  DuplicateTaskTemplateMutation,
  DuplicateTaskTemplateMutationVariables,
  TaskTemplateFieldsForCustomColumnQuery,
  TaskTemplateFieldsForCustomColumnQueryVariables,
  TaskTemplatesQuery,
  TaskTemplatesQueryVariables,
  UpdateTaskTemplateMutation,
  UpdateTaskTemplateMutationVariables,
  UpdateTaskTemplateStatusMutation,
  UpdateTaskTemplateStatusMutationVariables,
} from 'types/graphql'

import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const Get = gql`
  query TaskTemplatesQuery($input: GetTaskTemplatesInput) {
    taskTemplates: allTaskTemplates(input: $input) {
      ...TaskTemplateOverviewFragment
    }
  }
  fragment TaskTemplateOverviewFragment on TaskTemplate {
    ...TaskTemplateFragment
    usedInRecordTemplates {
      id
      name
    }
  }
`
export const useTaskTemplatesQuery = () => {
  const organizationId = useMyOrgId()
  return useQuery<TaskTemplatesQuery, TaskTemplatesQueryVariables>({
    queryKey: [QueryKey.TaskTemplates, organizationId],
    queryDocument: Get,
    variables: { input: { organizationId } },
    enabled: !!organizationId,
  })
}

const Create = gql`
  mutation CreateTaskTemplateMutation($input: CreateTaskTemplateInput) {
    createTaskTemplate(input: $input) {
      id
    }
  }
`
export const useCreateTaskTemplateMutation = () => {
  return useMutation<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>({
    mutationDocument: Create,
  })
}

const UpdateStatus = gql`
  mutation UpdateTaskTemplateStatusMutation($id: Int!, $status: TaskTemplateStatus!) {
    updateTaskTemplateActive(id: $id, status: $status) {
      id
    }
  }
`

export const useUpdateTaskTemplateStatusMutation = () => {
  return useMutation<UpdateTaskTemplateStatusMutation, UpdateTaskTemplateStatusMutationVariables>({
    mutationDocument: UpdateStatus,
  })
}

const Update = gql`
  mutation UpdateTaskTemplateMutation($id: Int!, $input: UpdateTaskTemplateInput!) {
    updateTaskTemplate(id: $id, input: $input) {
      id
    }
  }
`
export const useUpdateTaskTemplateMutation = () => {
  return useMutation<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>({
    mutationDocument: Update,
  })
}

const Duplicate = gql`
  mutation DuplicateTaskTemplateMutation($id: Int!) {
    duplicateTaskTemplate(id: $id) {
      id
    }
  }
`

export const useDuplicateTaskTemplateMutation = () => {
  return useMutation<DuplicateTaskTemplateMutation, DuplicateTaskTemplateMutationVariables>({
    mutationDocument: Duplicate,
  })
}

const TaskTemplateFieldsForCustomColumn = gql`
  query TaskTemplateFieldsForCustomColumnQuery($input: GetTaskTemplatesInput) {
    taskTemplates(input: $input) {
      ...TaskTemplateFieldsForCustomColumnFragment
    }
  }
  fragment TaskTemplateFieldsForCustomColumnFragment on TaskTemplate {
    id
    identifier
    fieldGroup {
      id
      fields {
        id
        isApplicationField
        label
        type
      }
    }
  }
`
export const useTaskTemplateFieldsForCustomColumnQuery = () => {
  const organizationId = useMyOrgId()
  return useQuery<
    TaskTemplateFieldsForCustomColumnQuery,
    TaskTemplateFieldsForCustomColumnQueryVariables
  >({
    queryKey: [QueryKey.TaskTemplates, 'fieldsForCustomColumn', organizationId],
    queryDocument: TaskTemplateFieldsForCustomColumn,
    variables: { input: { organizationId } },
    enabled: !!organizationId,
  })
}
